/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("UserInterfaceController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class UserInterfaceController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class UserInterfaceController extends cls.ControllerBase /** @lends classes.UserInterfaceController.prototype */ {
    static __name = "UserInterfaceController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      // END WARNING

      // vm behaviors
      this._addBehavior(cls.FocusPseudoSelectorBehavior);
      this._addBehavior(cls.RuntimeStatusVMBehavior);
      this._addBehavior(cls.ApplicationTitleVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.CurrentWindowVMBehavior);
      this._addBehavior(cls.ApplicationImageVMBehavior);
      this._addBehavior(cls.DBDateVMBehavior);
      this._addBehavior(cls.CurrentTitleVMBehavior);

      // 4st behaviors
      this._addBehavior(cls.Reverse4STBehavior);
      this._addBehavior(cls.BrowserMultiPage4STBehavior);
      this._addBehavior(cls.DesktopMultiWindow4STBehavior);

      // init application list 4ST values once with top parent application
      if (!this.getAnchorNode().attribute("procIdParent")) {
        // 4ST allows dynamic change on application lifecycle
        this._addBehavior(cls.ApplicationListVisible4STBehavior);
        this._addBehavior(cls.ApplicationListPosition4STBehavior);
        // first init occuring before 4ST are executed needed to get values preset before apps initialization
        context.ApplicationListService.initVisibilityAndPosition(this.getAnchorNode());
      }
      this._addBehavior(cls.WindowListVisible4STBehavior);
    }

    /**
     * @inheritDoc
     */
    destroy() {
      super.destroy();
    }

    _createWidget(type) {
      const widget = super._createWidget(type);
      widget.setCharLengthSemantics(Boolean(this.getNodeBindings().anchor.attribute("charLengthSemantics")));

      // Hack to prevent firefox to relayout and change richtext cursors
      const messageWidget = widget.getMessageWidget();
      messageWidget.setDummyMessage();
      widget.addChildWidget(messageWidget);

      return widget;
    }
  }

  cls.UserInterfaceController = UserInterfaceController;
  cls.ControllerFactory.register("UserInterface", cls.UserInterfaceController);
});
